import { rollStatusCodes } from "@/shared/selectors/RollStatusSelector";
import { Tooltip } from "@mui/material";

type StatusTagProps = {
	status: { Code: string; Name: string };
};
export const RollStatusTag = ({ status }: StatusTagProps) => {
	if (!status || !status.Code || !status.Name) {
		return null;
	}

	let backgroundColor;
	const foundStatus = rollStatusCodes.find((code) => code.Code === status.Code);

	if (foundStatus) {
		backgroundColor = foundStatus.Color;
	} else {
		backgroundColor = rollStatusCodes.find((code) => code.Code === "K")?.Color;
	}

	return (
		<Tooltip title={status.Name} arrow>
			<div
				style={{
					width: "26px",
					height: "26px",
					borderRadius: 4,
					display: "inline-flex",
					alignItems: "center",
					justifyContent: "center",
					fontWeight: "bold",
					backgroundColor,
					color:
						status.Code === "B" || status.Code === "K" ? "#2E2E2E" : "white",
				}}
			>
				{status.Code.charAt(0).toUpperCase()}
			</div>
		</Tooltip>
	);
};
